module.exports = __webpack_public_path__ + "static/img/ANAB-Symbol-Black.94294a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/ANAB-Symbol-Black.png
// module id = 563
// module chunks = 4